import React, { FC } from 'react';
import { Ville } from '../../entity.types';
import { EntityChartBlock } from '../components/EntityChartComponents';

type Props = {
  villes: Array<Ville>;
  children: (data: { sortedVilles: Array<Ville> }) => React.ReactNode;
};

export const VillesChartContainer: FC<Props> = ({ children, villes }) => {
  const sortedVilles = villes.sort((v1, v2) => v2.count - v1.count);
  return (
    <EntityChartBlock>
      {children({
        sortedVilles,
      })}
    </EntityChartBlock>
  );
};
